import {range} from './pure-utils/array-utils';

export const hourTimeOptions = range(0, 24).map(hour => {
  let hour12 = hour % 12;
  if (hour12 === 0) {
    hour12 = 12;
  }
  return {label: `${hour12}:00 ${hour < 12 ? 'AM' : 'PM'}`, value: hour};
});
export const globalUuid = '00000000-0000-4000-a000-000000000000';
